import { Injectable } from '@angular/core'
import { AppService } from '../../../../../core/service/Base.Service'
import { DataTransferObject } from '../../../../../core/entities/DataTransferObject';
//import { DataTransferObject } from '../../../../core/entities/DataTransferObject';

@Injectable()
export class SMCourseService extends AppService<any>{

    constructor() {
        super('SMCourse');
    }
    async getCourse() {
        const result = await this.get('');
        return result;
    }

    async getEntityCourse() {
        const result = await this.get('EntityCourse');
        return result;
    }


    async getCourseData(insititute) {
        const result = await this.get(insititute);
        return result;
    }

    async getCourseEntity(entityid) {
        const result = await this.getEntityCourse();
        return result;
    }

    async getCourseExtend() {

        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseExtend', [entityid]);
        return result;
    }

    async getCourseExtends(academicyearid) {

        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseExtend', [entityid , academicyearid]);
        return result;
    }


    async getCourseExtendV2() {

        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseExtendV2', [entityid]);
        return result;
    }


    async getApplicationRegisterCourse(entityid, academicyearid, batchid) {

        const result = await this.get('ApplicationRegisterCourse', [entityid, academicyearid, batchid]);
        return result;
    }

    async getApplicationRegisterSectionWise(entityid, academicyearid, batchid) {

        const result = await this.get('ApplicationRegisterSectionWise', [entityid, academicyearid, batchid]);
        return result;
    }

    async getclientCourse() {
        const result = await this.get('ClientCourse');
        return result;
    }

    async getClientCourses() {
        const result = await this.get('ClientCourses');
        return result;
    }

    async   getClientCourse() {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('ClientCourse', [entityid ,]);
        return result;
    }

    async getCourseAgainstAdmRegister(batchid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseAgainstAdmRegister', [entityid , batchid]);
        return result;
    }



    async getCourseclient() {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('ClientCourse', [entityid]);
        return result;
    }

    async getEntityQuestionnaireCourse(questionnairetypeid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('EntityQuestionnaireCourse', [entityid, questionnairetypeid]);
        return result;
    }

    async getsectionAgainstCourse(courseid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('SectionAgainstCourse', [courseid, entityid]);
        return result;
    }
    
    async getsectionAgainstToCourse(courseid,entityid) {
        const result = await this.get('SectionAgainstCourse', [courseid, entityid]);
        return result;
    }

    async getBatchCourse(batchid) {
        const result = await this.get('BatchCourse', batchid);
        return result;
    }
    async gatTeacherClass(courseid, sectionid) {
        const result = await this.get('TeacherClass', [courseid, sectionid]);
        return result;
    }

    async getSectionCourse(courseid) {

        const result = await this.get('SectionCourse', courseid);
        return result;
    }

    async getExamCourses(examid) {

        const result = await this.get('SectionCourse', examid);
        return result;
    }

    async getTeacherCourse(teacherid) {
        const result = await this.get('TeacherCourse', teacherid);
        return result;
    }

    async getCourseAgainstTeacher() {
        const result = await this.get('CourseAgainstTeacher');
        return result;
    }

    async getTeacherClasses(teacherid) {

        const result = await this.get('TeacherCourse', teacherid);
        return result;
    }

    async getTeacherSection(teacherid, courseid) {

        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('TeacherSection', [teacherid, courseid]);
        return result;
    }

    async getTeacherCourses(teacherid) {

        const result = await this.get('EntityTeacherCourses', teacherid);
        return result;
    }

    async getEntityTeacherSection(teacherid, courseid) {

        const result = await this.get('EntityTeacherSection', [teacherid, courseid]);
        return result;
    }

    async getCourseList() {
        let entityid = (Number(this.localStorage.get('selectedEntity')));
        if (entityid > 0) {
            const result = await this.get('CourseList', [entityid]);
            return result;
        }
        else {
            console.log("Course List, Entity cannot be empty")
        }
    }

    async getSubjectlist() {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('SubjectList', [entityid]);
        return result;
    }

    async getSubjectById(courseid) {
        const result = await this.get('SubjectById', courseid);
        return result;
    }

    async getSubjectAssessment(examtypeid) {
        const result = await this.get('SubjectAssessment', examtypeid);
        return result;
    }

    async getCourseSectionByEntity() {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseSectionByEntity', [entityid]);
        return result;
    }

    async getentityCourseList() {
        const result = await this.get('ClientCourse', [Number(this.localStorage.get('selectedEntity'))]);
        return result;
    }

    async getCourseAgaintExtend() {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseAgaintExtend', [entityid]);
        return result;
    }

    async getCourseDetail(courseid) {
        if (courseid) {
            const result = await this.get('CourseDetail', [courseid]);
            return result;
        }
    }

    async getExamRegisterCourseDtl(examid, examtypeid) {
        examid = examid > 0 ? examid : 0;
        examtypeid = examtypeid > 0 ? examtypeid : 0;
        const result = await this.get('ExamRegisterCourseDtl', [examid, examtypeid]);
        return result;
    }

    async getExamCourse(examid) {
        examid = Number(examid) > 0 ? examid : 0;
        const result = await this.get('ExamCourse', [examid]);
        return result;
    }

    async getTeacherClass(teacherid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('TeacherClasses', [teacherid, entityid]);
        return result;
    }

    async getEntityCourseTeacherSubject(teacherid, courseid) {
        const result = await this.get('EntityCourseTeacherSubject', [teacherid, courseid]);
        return result;
    }
    async getEntitySectionAgainstCourse(courseid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('EntitySectionAgainstCourse', [entityid, courseid]);
        return result;
    }


    async getmeetinghost(courseid, sectionid, meetingid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('MeetingHost', [entityid, courseid, sectionid, meetingid]);
        return result;
    }

    async gatTeacherClasses(courseid, sectionid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('TeacherClass', [entityid, courseid, sectionid]);
        return result;
    }

async Bulkcoursesaving(Data){
        const _data = <DataTransferObject<any>>{
            Data: Data,
        };
        
        const result = await this.post('Bulkcoursesaving',_data);
        
        return result;
    }


    async getCourseAgainstAcadmeicyear(academicyearid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('ClientCourse', [entityid , academicyearid]);
        return result;
    }


    async getCourseExtendsV2(academicyearid) {

        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseExtendV2', [entityid, academicyearid]);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shell/forms/academic/CourseAndBatch/SM-Course/smcourse.service.ts